import * as React from "react";

const SignInUserRssw: React.FC = () => {
    return (
        <svg width="168" height="168" viewBox="0 0 168 168" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor" fillRule="nonzero">
                <path d="M5.25 168c-2.9 0-5.25-2.348-5.25-5.25v-32.106c0-25.886 21.062-46.947 46.947-46.947h32.106a46.618 46.618 0 0 1 18.585 3.825 5.245 5.245 0 0 1 2.74 6.901c-1.147 2.662-4.243 3.877-6.9 2.738a36.272 36.272 0 0 0-14.426-2.964H46.949c-20.098 0-36.447 16.35-36.447 36.447v32.106c0 2.902-2.351 5.25-5.25 5.25H5.25ZM131.25 94.5c20.264 0 36.75 16.488 36.75 36.75S151.514 168 131.25 168 94.5 151.512 94.5 131.25s16.486-36.75 36.75-36.75Zm16.02 25.82a5.248 5.248 0 0 0-7.423 0l-10.72 10.726-2.856-2.856a5.248 5.248 0 0 0-7.424 0 5.248 5.248 0 0 0 0 7.424l6.567 6.567a5.248 5.248 0 0 0 7.425 0l14.433-14.438a5.247 5.247 0 0 0-.002-7.423ZM63 0c20.264 0 36.75 16.488 36.75 36.75S83.264 73.5 63 73.5 26.25 57.012 26.25 36.75 42.736 0 63 0Zm0 10.5c-14.474 0-26.25 11.776-26.25 26.25S48.526 63 63 63s26.25-11.776 26.25-26.25S77.474 10.5 63 10.5Z" />
            </g>
        </svg>
    );
};

export default React.memo(SignInUserRssw);
